import React, {useCallback, useEffect, useState} from 'react';
import {PageHeader, PageWidget} from "../../components/contentComponents";
import {Icon} from "@iconify/react";
import {Button, Divider, Popconfirm, Select, Table, Space} from "antd";
import {useDispatch, useSelector} from "react-redux";
import TableWrapper from "../../components/antdWrappers/TableWrapper";
import {
    loadSignalAssetEvents,
    loadStrategySignalEvents,
    updatePagination,
    updateSelectedStrategies
} from "./signalsSlice";
import SignalAssetEventDetails from "./SignalAssetEventDetails";

const Option = Select.Option;


const StrategySignalsPage = () => {

    const columns = [
        {
            title:
                <React.Fragment>
                    <div>Стратегия</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {strategyCode} = signal;
                return (
                    <React.Fragment>
                        {strategyCode}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Время</div>
                </React.Fragment>
            , dataIndex: 'edate'
        },
        {
            title:
                <React.Fragment>
                    <div>Тикер</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {security: { id, ticker }} = signal;
                return (
                    <React.Fragment>
                        {id}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Цена</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {price = undefined} = signal;
                return (
                    <React.Fragment>
                        {price}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Тип сигнала</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {signalType = undefined} = signal;
                return (
                    <React.Fragment>
                        {signalType}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Тип события</div>
                </React.Fragment>
            , dataIndex: 'eventType'
        }
    ];

    const dispatch = useDispatch();

    const {
        signalEvents,
        loading,
        pagination,
        selectedStrategies,
        signalAssetEvents,
        loadingSignalAssetEvents
        // error
    } = useSelector(state => state.strategySignals);
    const {strategies} = useSelector(state => state.adminStrategies);

    useEffect(() => {
        dispatch(loadStrategySignalEvents({pagination, selectedStrategies}));
    }, [dispatch, pagination.current, pagination.pageSize, selectedStrategies]);

    return(
        <>
            <PageHeader caption='Сигналы стратегий' />
            <PageWidget >
                <Space style={{ width: '100%' }} direction="vertical">
                    <div>
                        <Select
                            mode="multiple"
                            allowClear
                            showSearch
                            style={{ width: '40%' }}
                            placeholder="Выберите стратегию"
                            value={selectedStrategies}
                            onChange={(value) => {
                                console.log(value);
                                dispatch(updateSelectedStrategies(value));
                            }}
                        >
                            {strategies.map(strategy => {
                                const op = <Option key={strategy.code} value={strategy.code}>{`${strategy.name}`}</Option>
                                return op;
                            })}
                        </Select>
                    </div>
                    <div>
                        <TableWrapper>
                            <Table
                                columns={columns}
                                rowKey='id'
                                dataSource={signalEvents}
                                loading={loading}
                                pagination={pagination}
                                size="small"
                                bordered
                                onChange={( pagination, tableFilters, sorter) => {
                                    const {field, order} = sorter;
                                    const sort = { field, order };
                                    dispatch(updatePagination(pagination));
                                }}
                                expandable={{
                                    expandedRowRender: (record) => <SignalAssetEventDetails
                                        assetEvents={signalAssetEvents[record.id]}
                                        loading={loadingSignalAssetEvents[record.id]}
                                    />,
                                    onExpand: (expanded, record) => {
                                        if (expanded && !signalAssetEvents[record.id]) {
                                            dispatch(loadSignalAssetEvents(record.id));
                                        }
                                    }
                            }}/>
                        </TableWrapper>
                    </div>
                </Space>
            </PageWidget>
        </>
    )
}

export default StrategySignalsPage;
